import styled from 'styled-components';
import constants from '../../../../abstracts/constants';

const Subtitle = styled.h3`
  font-size: ${constants.MEDIUM};
  font-family: ${constants.blissPro};
`;

export default Subtitle;
